import { useEffect, useMemo } from 'react';
import { useFleetStore } from '@/stores/fleet';
import { useConditionsStore } from '@/stores/conditions';

/** Localização de referência (Baía de Guanabara) quando não há frota. */
const DEFAULT_LAT = -22.9;
const DEFAULT_LON = -43.16;

/**
 * Escolhe a posição mais recente da frota como ponto de referência das
 * condições marítimas e dispara o refresh (com cache). Chamado no AppLayout,
 * roda na entrada do app (após login) e quando a frota carrega.
 */
export function useConditionsRefresh() {
  const positions = useFleetStore((s) => s.positions);
  const refresh = useConditionsStore((s) => s.refresh);

  const ref = useMemo(() => {
    let best: { lat: number; lon: number; t: number; address?: string } | null = null;
    for (const p of positions.values()) {
      if (p.latitude == null || p.longitude == null) continue;
      const t = p.fixTime ? new Date(p.fixTime).getTime() : 0;
      if (!best || t > best.t) {
        best = { lat: p.latitude, lon: p.longitude, t, address: p.address };
      }
    }
    return best;
  }, [positions]);

  useEffect(() => {
    const lat = ref?.lat ?? DEFAULT_LAT;
    const lon = ref?.lon ?? DEFAULT_LON;
    refresh(lat, lon, ref?.address ?? null);
  }, [ref, refresh]);
}

/** Estado das condições + ação de refresh manual (forçado). */
export function useConditions() {
  const data = useConditionsStore((s) => s.data);
  const fetchedAt = useConditionsStore((s) => s.fetchedAt);
  const loading = useConditionsStore((s) => s.loading);
  const error = useConditionsStore((s) => s.error);
  const lat = useConditionsStore((s) => s.lat);
  const lon = useConditionsStore((s) => s.lon);
  const refresh = useConditionsStore((s) => s.refresh);
  return { data, fetchedAt, loading, error, lat, lon, refresh };
}
